import { render, staticRenderFns } from "./RemoteWarning.vue?vue&type=template&id=28179d8d&scoped=true"
import script from "./RemoteWarning.vue?vue&type=script&lang=js"
export * from "./RemoteWarning.vue?vue&type=script&lang=js"
import style0 from "./RemoteWarning.vue?vue&type=style&index=0&id=28179d8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28179d8d",
  null
  
)

export default component.exports